// src/components/Header.js
import React, { useState } from 'react';
import { Navbar, Nav, Row, Col } from 'react-bootstrap';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header id="default_header" className="header_style_1">
      {/* Mobile Top Header */}
      <div className="header_top_mobile d-md-none">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="topbar-mobile text-center">
                <div className="address-line">
                  <span className="topbar-label"><i className="fa fa-map-marker"></i> &nbsp; </span>
                  <span className="topbar-hightlight">Near SBI Bank, Kanta Choraha, Kalwar Road, Jhotwara, Jaipur (Raj)</span>
                </div>
                <div className="email-line">
                  <span className="topbar-hightlight">
                    <a href="mailto:deepakplywood@yahoo.com">
                      <i className="fa fa-envelope"></i> deepakplywood@yahoo.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button
            className="navbar-toggler mobile-menu-btn"
            type="button"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>

      {/* Desktop Top Header */}
      <div className="header_top d-none d-md-block">
        <div className="px-5">
          <div className="row">
            <div className="col-md-9 col-lg-9">
              <div className="topbar-left" style={{ paddingLeft: '58px' }}>
                <ul className="list-inline">
                  <li>
                    <span className="topbar-label"><i className="fa fa-map-marker"></i>  </span>
                    <span className="topbar-hightlight">Near SBI Bank, Kanta Choraha, Kalwar Road, Jhotwara, Jaipur (Raj)</span>
                  </li>
                  <li>
                    
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-lg-3 right_section_header_top d-flex align-items-center justify-content-end">
              <div className="float-right" style={{ paddingRight: '58px' }}>
                {/* <div className="social_icon">
                  <ul className="list-inline">
                    <li><a className="fa fa-facebook" href="https://www.facebook.com/profile.php?id=61566204182461" title="Facebook" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a className="fa fa-twitter" href="https://x.com/deepakplywoods" title="Twitter" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a className="fa fa-instagram" href="https://www.instagram.com/deepakplywoodtimbersjaipur/" title="Instagram" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a className="fa fa-youtube" href="https://www.youtube.com/@Deepakplywoodjaipur " title="Instagram" target="_blank" rel="noopener noreferrer"></a></li>
                  </ul>
                </div> */}
                <span className="topbar-hightlight"><a href="mailto:deepakplywood@yahoo.com"><i className="fa fa-envelope"></i> deepakplywood@yahoo.com</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="header_bottom">
        <div className="px-4">
          <Row className="align-items-center">
            <Col lg={5} md={12}>
              <div className="logo" style={{ paddingLeft: '58px' }}>
                <a href="/"><img src="images/logos/logo-deepak.png" alt="logo" /></a>
              </div>
            </Col>
            <Col lg={7} md={12}>
              <nav className="navbar navbar-expand-lg">
                <div className="collapse navbar-collapse" id="navbarNav" style={{ justifyContent: 'space-between' }}>
                  <ul className="navbar-nav" style={{ width: '80%', display: 'flex', justifyContent: 'space-between' }}>
                    <li className="nav-item" style={{ flex: '1', textAlign: 'center' }}>
                      <a className="nav-link" href="/" style={{ whiteSpace: 'nowrap' }}>Home</a>
                    </li>
                    <li className="nav-item" style={{ flex: '1', textAlign: 'center' }}>
                      <a className="nav-link" href="/about" style={{ whiteSpace: 'nowrap' }}>About Us</a>
                    </li>
                    <li className="nav-item" style={{ flex: '1', textAlign: 'center' }}>
                      <a className="nav-link" href="/gallery" style={{ whiteSpace: 'nowrap' }}>Gallery</a>
                    </li>
                    <li className="nav-item" style={{ flex: '1', textAlign: 'center' }}>
                      <a className="nav-link" href="/brands" style={{ whiteSpace: 'nowrap' }}>Our Brand</a>
                    </li>
                    <li className="nav-item" style={{ flex: '1', textAlign: 'center' }}>
                      <a className="nav-link contact-btn" href="/contact" style={{ whiteSpace: 'nowrap' }}>Contact Us</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </Col>
          </Row>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav-menu ${isMenuOpen ? 'show' : ''} d-md-none`}>
        <div className="mobile-nav-content">
          <ul className="mobile-nav-list">
            <li><a href="/" className="mobile-nav-link">Home</a></li>
            <li><a href="/about" className="mobile-nav-link">About Us</a></li>
            <li><a href="/gallery" className="mobile-nav-link">Gallery</a></li>
            <li><a href="/brands" className="mobile-nav-link">Our Brand</a></li>
            <li><a href="/contact" className="mobile-nav-link contact-btn-mobile">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;

